// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS POUR ACCUEIL */

.statisticClasnam {
    /* width: 100%; */
    border-radius: 0.7rem;
    border-style: solid;
    border-color: #43CE0C;
}
 .iconCards {
        font-size: 50px; 
        color: #ffffff;
        background-color: #43CE0C;
        padding: 10px;
        border-radius: 0.5rem;
        margin-top: -10px;
        float: left;
}

 .iconCards1 {
        font-size: 50px; 
        color: #ffffff;
        background-color: #43CE0C;
        padding: 10px;
        border-radius: 0.5rem;
        margin-top: -10px;
        float: left;
        /* border-top-left-radius: 2rem; */
        clip-path: polygon(15px 0, 100% 0, 100% 100%, 0 100%, 0 15px);
}

 .titre {
    /* font-size: 15px; */
    /* color: #000000;   */
    margin-top: 10px;
    margin-bottom: 15px;
}
 .nombre {
    margin-top: -2px;
    font-weight: bold;
    color: #000000;
 }`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/dashboard.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;IACI,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;AACzB;CACC;QACO,eAAe;QACf,cAAc;QACd,yBAAyB;QACzB,aAAa;QACb,qBAAqB;QACrB,iBAAiB;QACjB,WAAW;AACnB;;CAEC;QACO,eAAe;QACf,cAAc;QACd,yBAAyB;QACzB,aAAa;QACb,qBAAqB;QACrB,iBAAiB;QACjB,WAAW;QACX,kCAAkC;QAClC,6DAA6D;AACrE;;CAEC;IACG,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;AACvB;CACC;IACG,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;CACjB","sourcesContent":["/* CSS POUR ACCUEIL */\r\n\r\n.statisticClasnam {\r\n    /* width: 100%; */\r\n    border-radius: 0.7rem;\r\n    border-style: solid;\r\n    border-color: #43CE0C;\r\n}\r\n .iconCards {\r\n        font-size: 50px; \r\n        color: #ffffff;\r\n        background-color: #43CE0C;\r\n        padding: 10px;\r\n        border-radius: 0.5rem;\r\n        margin-top: -10px;\r\n        float: left;\r\n}\r\n\r\n .iconCards1 {\r\n        font-size: 50px; \r\n        color: #ffffff;\r\n        background-color: #43CE0C;\r\n        padding: 10px;\r\n        border-radius: 0.5rem;\r\n        margin-top: -10px;\r\n        float: left;\r\n        /* border-top-left-radius: 2rem; */\r\n        clip-path: polygon(15px 0, 100% 0, 100% 100%, 0 100%, 0 15px);\r\n}\r\n\r\n .titre {\r\n    /* font-size: 15px; */\r\n    /* color: #000000;   */\r\n    margin-top: 10px;\r\n    margin-bottom: 15px;\r\n}\r\n .nombre {\r\n    margin-top: -2px;\r\n    font-weight: bold;\r\n    color: #000000;\r\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
